var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.pageTemplate,{key:_vm.key,tag:"component",staticClass:"home"})
}
var staticRenderFns = []

export { render, staticRenderFns }